module.exports = __webpack_public_path__ + "img/table_empty.66ffc630.png";